/**
 * Helper function to determine domain identifier
 * @returns {string} 'thc' for technorama domain, 'bb' for bigbox domain
 */
export const getDomainIdentifier = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("technorama.lt")) {
    return "thc";
  } else if (hostname.includes("bigbox.lt")) {
    return "bb";
  } else {
    return "bb";
  }
};
